import { render, staticRenderFns } from "./newTwo.vue?vue&type=template&id=f7f2c2be&scoped=true&"
import script from "./newTwo.vue?vue&type=script&lang=js&"
export * from "./newTwo.vue?vue&type=script&lang=js&"
import style0 from "./newTwo.vue?vue&type=style&index=0&id=f7f2c2be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f2c2be",
  null
  
)

export default component.exports